// Register GSAP plugin and set defaults
gsap.registerPlugin(ScrollTrigger);
gsap.defaults({ ease: "none", duration: 2 });

// Create a timeline for the panels
const tldriver = gsap.timeline({ defaults: { ease: "none", duration: 2 } });
tldriver
  .from(".x-red", { xPercent: -100 })
  .from(".pro-red", { xPercent: 100 });

// Get all panels
let panels = gsap.utils.toArray(".panel");

// Responsive ScrollTrigger setup
gsap.matchMedia().add("(max-width: 1180px)", () => {
  ScrollTrigger.create({
    animation: tldriver,
    trigger: "#three-drivers-container",
    start: "top 25%", // Adjust start for smaller viewports
    end: "+=1000",
    scrub: true,
    pin: true,
    anticipatePin: 1,
    onUpdate: (self) => {
      if (self.direction < 0) {
        // Disable the animation when scrolling up
        self.animation.pause();
      } else {
        // Enable the animation when scrolling down
        self.animation.play();
      }
    },

    // Add snap functionality for smaller viewports
   snap: {
      // Snap to nearest panel only
      snapTo: (progress) => {
        const snapPoint = Math.round(progress * (panels.length - 1)) / (panels.length - 1);
        return snapPoint;
      },
      duration: { min: 0.8, max: 1.5 }, // Slow snapping for better control
      delay: 1, // Remove additional delay
      ease: "power3.inOut", // Keep smooth easing
    },
  });
});

gsap.matchMedia().add("(min-width: 1181px)", () => {
  ScrollTrigger.create({
    animation: tldriver,
    trigger: "#three-drivers-container",
    start: "top top", // Adjust start for larger viewports
    end: "+=1000", // Use viewport height for scroll distance
    scrub: true,
    pin: true,
    anticipatePin: 1,

    // Add snap functionality for larger viewports
    // snap: {
    //   snapTo: 1 / (panels.length - 1), // Snap to based on panel index
    //   duration: { min: 0.2, max: 0.5 },
    //   delay: 0.2,
    //   ease: "power2.inOut",
    // }
  });
});



// Arrow animations
let arrow = document.querySelector('.arrow');
let arrowRight = document.querySelector('.arrow-right');

// Animate the arrow if it exists
if (arrow) {
  gsap.to(arrow, { y: 12, ease: "power1.inOut", repeat: -1, yoyo: true, duration: 0.5 });
}

// Animate the arrow-right if it exists
if (arrowRight) {
  gsap.to(arrowRight, { x: -12, ease: "power1.inOut", repeat: -1, yoyo: true, duration: 0.5 });
}

// Import SplitType and set up text animation
document.addEventListener('DOMContentLoaded', function () {
  import('https://cdn.skypack.dev/split-type@0.3.3').then(({ default: SplitType }) => {

    // GSAP Timeline for Highlight Text
    const tlthick = gsap.timeline();
    const splitText = SplitType.create('h1.highlight-text, h2.highlight-text', { types: 'words' });
    const splitWords = splitText.words;

    // Observer listens for when it's in view, then runs the animation
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Animate the highlight text
          tlthick.fromTo(".highlight-text", {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 1,
            ease: 'linear'
          });

          // Function to animate the text
          splitWords.forEach(function (item, index) {
            const width = item.offsetWidth;
            const dur = (width / 100) / 7; // Adjust speed based on word width

            // GSAP Timeline for individual words
            tlthick.fromTo(item, {
              backgroundPosition: "100%"
            }, {
              duration: dur,
              ease: 'linear',
              stagger: index * 0.1, // Stagger words based on index
              backgroundPosition: "0"
            });
          });

          // Animate the rotate text
          tlthick.fromTo(".rotate", {
            x: -500,   // Start position (off-screen left)
            opacity: 0 // Start with opacity 0
          }, {
            x: 0,      // End position (original position)
            opacity: 1, // End with opacity 1
            duration: 0.7, // Duration of the slide-in effect
            stagger: 0.5, // Stagger each element by 0.5 seconds
            ease: 'power3.out',
            delay: 1.2  // Delay the start of this animation
          }, "-=1");  // Overlap with the end of previous animations
          
          // Animate the <p> text fade-in after all other animations
          tlthick.fromTo("p", {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 1, // Duration for the fade-in effect
            ease: 'power1.out',
          });

          // Unobserve the element after animation to prevent it from replaying
          observer.unobserve(entry.target);
        }
      });
    });

    // Tell the observer which elements to track
    observer.observe(document.querySelector('.highlight-text'));
  });
});

// Timeline for the first panel (xx-red)
const tlXX = gsap.timeline({
  scrollTrigger: {
    trigger: ".xx-red",
    start: "top center",
    end: "bottom center",
    scrub: true,  // Allows the animation to link to scroll
    once: true,   // Only play once
    onEnter: () => {
      // Animate in the correct order
      gsap.fromTo("h2.firsth2", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1 });
      gsap.fromTo(".xx-red h3", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .2 }); 
      gsap.fromTo("h2.lasth2", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .4 }); 
      gsap.fromTo("a", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .6 });
    }
  }
});


// Timeline for the second panel (x-red)
const tlX = gsap.timeline({
  scrollTrigger: {
    trigger: ".x-red",
    start: "top center",
    end: "bottom center",
    scrub: true,
    once: true,   // Only play once
    onEnter: () => {
       gsap.fromTo("h2.firsth2", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1 });
      gsap.fromTo(".x-red h3", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .2 }); 
      gsap.fromTo("h2.lasth2", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .4 }); 
      gsap.fromTo("a", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .6 });
    }
  }
});

// Timeline for the third panel (pro-red)
const tlPRO = gsap.timeline({
  scrollTrigger: {
    trigger: ".pro-red",
    start: "top center",
    end: "bottom center",
    scrub: true,
    once: true,   // Only play once
    onEnter: () => {
       gsap.fromTo("h2.firsth2", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1 });
      gsap.fromTo(".pro-red h3", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .2 }); 
      gsap.fromTo("h2.lasth2", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .4 }); 
      gsap.fromTo("a", { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: .6 });
    }
  }
});
